import React, { useEffect, useState } from "react";
import "./OrderlistPage.css";
import { Container, Dropdown, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import NodatafoundPage from "../../nodatafound/components/NodatafoundPage";
import no_orders from "./../../../assets/order_empty_icon.svg";
import { useTranslation } from "react-i18next";
import { receivedOrdercount } from "../../user/dashboard/redux/actions";
import profileDefault from "../../../assets/profile_default.png";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import dots_vertical from "../../../assets/dots_vertical.svg";
import { ORDER_STATUS, ORDERLIST_VENDOR, SEND_ORDERSTATUS } from "../../constants/apiurl";
import { getRequestcall } from "../../comman/util/getRequest";
import { postRequestcall } from "../../comman/util/postRequest";
import PaginationPage from "../../comman/components/PaginationPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import { fetchLogindata } from "../../login/redux/actions";
import { toast } from "react-toastify";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
const DeletepopupPage = React.lazy(() =>
  import("../../modal/components/DeletepopupPage")
);

function OrderlistPage(props) {
 
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { access_token } = props;
  const [filterDate, setFilterDate] = useState({
    from_date: "",
    to_date: "",
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.deletepop.deleteorder"),
    sub_title: t("pages.deletepop.sub_title"),
    name: "",
    id: "",
    status: "",
    type: t("pages.deletepop.order"),
  });
  const [empty, setEmpty] = useState();
  const [orderlist, setOrderlist] = useState({});
  

  const orderStatus = [
    {
      orderstatus: "Accepted",
      orderstatus_tr: "Kabul edilmiş",
    },
    {
      orderstatus: "Packed",
      orderstatus_tr: "paketlenmiş",
    },
    {
      orderstatus: "Dispatched",
      orderstatus_tr: "Sevk edilen",
    },
    {
      orderstatus: "Delivered",
      orderstatus_tr: "Teslim edilmiş",
    },
    {
      orderstatus: "Cancelled",
      orderstatus_tr: "İptal edildi",
    },
  ];
  useEffect(() => {
    let order = {
      from_date: "",
      to_date: "",
      id: "",
      status: "",
      page: "",
    };
    callGetOrderlist(order);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.deletepop.deleteorder"),
      sub_title: t("pages.deletepop.sub_title"),
      name: "",
      id: "",
      status: "",
      type: t("pages.deletepop.order"),
    });
    props?.fetchHeaderContent(t("pages.sidenav.received_orders"), "", "");
    // eslint-disable-next-line
  }, [props?.language]);

  const callGetOrderlist = async (order) => {
    let getUrl;
    if (props?.dashboard === true) {
     getUrl = ORDERLIST_VENDOR +
      `?from_date=${order?.from_date}&to_date=${order?.to_date}&id=${order?.id}&status=${order?.status}&page=${order?.page}&received_date=${"no"}`;
    }else{
      getUrl = ORDERLIST_VENDOR +
      `?from_date=${order?.from_date}&to_date=${order?.to_date}&id=${order?.id}&status=${order?.status}&page=${order?.page}&received_date=${"yes"}`;
    }
    let responceList = await getRequestcall(getUrl, access_token);
    if (responceList?.status === 200) {
      const resultList = await responceList.json();
      if (resultList?.data?.data.length !== 0) {
        if (props?.dashboard === true) {
          const recentlySold = resultList?.data?.data?.filter((item, index) => index < 4);
          setOrderlist({
            data: recentlySold,
          });
        } else {
          setOrderlist(resultList?.data);
          props.receivedOrdercount(
            resultList?.data?.data?.new_received_orders_count
          );
        }
        setEmpty(false);
      } else {
        setEmpty(true);
        props.receivedOrdercount(0);
      }
    } else if (responceList?.status === 400) {
      const resultList = await responceList.json();
      if (resultList?.error?.is_deleted === true) {
        props?.clearStoredetail([]);
        props.logindata.type = "user";
        props.fetchLogindata(props.logindata);
        toast.error(resultList?.errors);
        navigate("/vendor/");
      } else {
        if (typeof resultList?.error !== 'string') {
          toast.error(resultList?.errors);
        }
        setEmpty(true);
      }
    }
  };

  const callPaginationOrderList = async (pages) => {
    let order = {
      from_date: "",
      to_date: "",
      id: "",
      status: "",
      page: pages,
    };
    callGetOrderlist(order);
  };

  const onStartDate = async (e) => {
    setFilterDate({
      ...filterDate,
      from_date: e,
    });
    let order = {
      from_date: moment(e).format('YYYY-MM-DD'),
      to_date: filterDate?.to_date ?moment(filterDate?.to_date).format('YYYY-MM-DD'):filterDate?.to_date,
      id: "",
      status: "",
      page: orderlist?.current_page,
    };
    callGetOrderlist(order);
  };

  const onEndDate = async (e) => {
    setFilterDate({
      ...filterDate,
      to_date: e,
    });
    let order = {
      from_date: filterDate?.from_date ?moment(filterDate?.from_date).format('YYYY-MM-DD'):filterDate?.from_date,
      to_date: moment(e).format("YYYY-MM-DD"),
      id: "",
      status: "",
      page: orderlist?.current_page,
    };
    callGetOrderlist(order);
  };

  const productDelete = (item) => {
    setDeleteinfo({
      ...deleteInfo,
      name: item.display_order_id,
      id: item.id,
      status: item?.order_status,
    });
    setDeleteModal(true);
  };

  const callCancelOrders = async () => {
    let geturl =
      ORDER_STATUS +
      `?order_status=${t("pages.Cancelled")}&id=${
        deleteInfo.id
      }&lang=${props?.language?.toLowerCase()}`;
    let getChangeorderapiResponce = await postRequestcall(
      geturl,
      access_token,
      ""
    );
    if (getChangeorderapiResponce?.status === 200) {
      let order = {
        from_date: filterDate?.from_date,
        to_date: filterDate?.to_date,
        id: "",
        status: "",
        page: orderlist?.current_page,
      };
      await callGetOrderlist(order);
      let getOrderurl = SEND_ORDERSTATUS + `?order_status=${t("pages.Cancelled")}&id=${deleteInfo.id}&lang=${props?.language?.toLowerCase()}`
      await postRequestcall(getOrderurl,access_token,"");
      toast.success(t('pages.Order has been cancelled'))
    }
  };

  return (
    <div className="col-xl-9 main-content orderlist-centent">
      <div className="d-flex align-center justify-content-between align-items-start">
        {props?.dashboard !== true && (
          <>
            <h5 className="header-title">{t("pages.receiveorder.title")}</h5>
            <div className="filtering d-flex align-center">
              {/* <Form.Control
                onChange={(e) => onStartDate(e)}
                name={"from_date"}
                value={filterDate?.from_date}
                className={"date-picker"}
                type="date"
              /> */}
              <ReactDatePicker
                locale={props?.language.toLowerCase()}
                className="form-control date-picker"
                showIcon selected={filterDate?.from_date ? filterDate?.from_date : null}
                dateFormat={"dd-MM-yyyy"}
                onChange={(date) => onStartDate(date)}
                placeholderText={t('pages.dd-mm-yyyy')}
              />
              <span className="mx-2"> {t('pages.to')} </span>
              {/* <Form.Control
                onChange={(e) => onEndDate(e)}
                name={"to_date"}
                value={filterDate?.to_date}
                className={"date-picker"}
                type="date"
              /> */}
              <ReactDatePicker
                locale={props?.language.toLowerCase()}
                className="form-control date-picker"
                showIcon selected={filterDate?.to_date ? filterDate?.to_date : null}
                dateFormat={"dd-MM-yyyy"}
                onChange={(date) => onEndDate(date)}
                placeholderText={t('pages.dd-mm-yyyy')}
              />
            </div>
          </>
        )}
      </div>
      <Row className="mt-2 mb-3 sold desktops">
        {empty ? (
          <NodatafoundPage
            className={"col-xl-12 main-content offerlist-centent"}
            image={no_orders}
            button={t("pages.backtodashboard")}
            title={t("pages.receiveorder.noorder")}
            description={t("pages.receiveorder.noorder_desc")}
            navigation={"/vendor/dashboard"}
          />
        ) : (
          <>
            <Container>
              <Row className="response-list-header">
                <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 ms-1">
                  <h5 className="row-header">
                    {t("pages.receiveorder.order")}
                  </h5>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                  <h5 className="row-header">
                    {t("pages.receiveorder.datetime")}
                  </h5>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2 ps-0">
                  <h5 className="row-header">
                    {t("pages.receiveorder.buyer")}
                  </h5>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                  <h5 className="row-header">
                    {t("pages.receiveorder.status")}
                  </h5>
                </div>
              </Row>
              {orderlist?.data?.map((item, index) => (
                <div className="response-list" key={index?.toString()}>
                  <Row className="align-center">
                    <div
                      className="col-sm-12 col-md-12 col-lg-4 col-xl-4"
                      onClick={() =>
                        navigate(
                          props?.dashboard === true
                            ? `/vendor/orders/${item?.id}`
                            : `${item?.id}`
                        )
                      }
                    >
                      <div className="product">
                        <div className="product-image">
                          <LazyLoadImage
                            src={
                              item?.image_url === null
                                ? profileDefault
                                : item?.image_url
                            }
                            onError={(e) => {
                              e.target.src = profileDefault;
                            }}
                            alt={""}
                          ></LazyLoadImage>
                        </div>
                        <div className="product-name">
                          <h5 className="mb-1 text-uppercase">
                            {t("pages.receiveorder.orderid")}:{" "}
                            {item?.display_order_id}
                          </h5>
                          <p className="mb-0">
                            {t("pages.receiveorder.totalorder")}:{" "}
                            {Number(item?.order_total).toFixed(2)}{" "}
                            {process.env.REACT_APP_CURRENCY_SYMBOL}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-sm-12 col-md-12 col-lg-3 col-xl-3"
                      onClick={() =>
                        navigate(
                          props?.dashboard === true
                            ? `/vendor/orders/${item?.id}`
                            : `${item?.id}`
                        )
                      }
                    >
                      <div className="item-box">
                        <h5 className="mobile-header">
                          {t("pages.receiveorder.datetime")}
                        </h5>
                        <h5>
                          {moment(item?.created_at).format("DD-MM-YYYY hh:mm A")}
                        </h5>
                      </div>
                    </div>
                    <div
                      className="col-sm-12 col-md-12 col-lg-2 col-xl-2"
                      onClick={() =>
                        navigate(
                          props?.dashboard === true
                            ? `/vendor/orders/${item?.id}`
                            : `${item?.id}`
                        )
                      }
                    >
                      <div className="item-box">
                        <h5 className="mobile-header">
                          {t("pages.receiveorder.buyer")}
                        </h5>
                        <h5 className="name">{item?.name}</h5>
                      </div>
                    </div>
                    <div
                      className="col-sm-12 col-md-12 col-lg-2 col-xl-2"
                      onClick={() =>
                        navigate(
                          props?.dashboard === true
                            ? `/vendor/orders/${item?.id}`
                            : `${item?.id}`
                        )
                      }
                    >
                      <div className="item-box border-bottom-0">
                        <h5 className="mobile-header">
                          {t("pages.receiveorder.status")}
                        </h5>
                        <label className={`statuss ${item?.order_status}`}>
                          {orderStatus.map((value, index) =>
                            <React.Fragment key={index?.toString()}>
                              {value.orderstatus === item.order_status ? (
                                props.language === "Tr" ? (
                                  value.orderstatus_tr
                                ) : (
                                  item?.order_status
                                )
                              ) : (
                                <React.Fragment/>
                              )}
                            </React.Fragment>
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-1 col-xl-1">
                      <Dropdown id="menu-drop" className="menu-drop">
                        <Dropdown.Toggle variant="success">
                          <img
                            src={dots_vertical}
                            height="25"
                            widht="25"
                            alt="option"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="drop-menus">
                          <Dropdown.Item
                            onClick={() =>
                              navigate(
                                props?.dashboard === true
                                  ? `/vendor/orders/${item?.id}`
                                  : `${item?.id}`
                              )
                            }
                          >
                            {t("pages.receiveorder.viewdetails")}
                          </Dropdown.Item>
                          {item?.order_status === "Delivered" ||
                          item?.order_status === "Cancelled" ? null : (
                            <Dropdown.Item onClick={() => productDelete(item)}>
                              {t("pages.receiveorder.cancelorder")}
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Row>
                </div>
              ))}
            </Container>
          </>
        )}
      </Row>
      {empty === false && orderlist?.total > 10 && (
        <div className="text-end">
          <PaginationPage
            changeCurrentpage={callPaginationOrderList}
            nopagination={empty}
            links={orderlist?.links}
          />
        </div>
      )}
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={callCancelOrders}
        />
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  storeDetail: state?.dashboard?.storeDetail,
  language: state?.languageState?.language,
  logindata: state?.login?.logindata,
});

export default connect(mapStateToProps, {
  receivedOrdercount,
  fetchHeaderContent,
  clearStoredetail,
  fetchLogindata
})(OrderlistPage);
